export const SET_SORTING = 'SET_SORTING';
